/**
 * @module Login
 * @since 3.81.0
 * @author Markus Kirscht <markus.kirscht@iventuregroup.com>
 * @author Jacob Viertel <jv@onscreen.net>
 *
 * Render the correct Login Form
 *
 * @example
 * ```html
 * <onsw-login></onsw-login>
 * ```
 */

import {Widget} from '@acng/frontend-stargazer';
import {userPoolFeature} from '../config/feature';
import {IS, OBJECT, typeguard} from '@acng/frontend-bounty/typeguard.js';
import {EVENT_SUBMIT, on} from '@acng/frontend-bounty';
import {inject} from 'acng/core/service/ng';
import {iOS} from 'acng/core/constant/iOS.js';

const MODULE = 'userPool/widget/login';
const VERBOSE = false;
DEBUG: if (VERBOSE) console.warn(`Import verbose ${MODULE}`);

userPoolFeature.defineWidget(
  'onsw-login',
  class extends Widget {
    async render() {
      ASSERT: typeguard(
        MODULE,
        this.nodes,
        OBJECT({
          form: IS(HTMLFormElement),
          nickname: IS(HTMLInputElement),
          password: IS(HTMLInputElement),
          rememberMe: IS(HTMLInputElement),
          submitBtn: IS(HTMLButtonElement),
        })
      );
      const {form, nickname, password, rememberMe} = this.nodes;
      const overlay = inject('onsOverlay').get('pageLogin');

      nickname.placeholder = await userPoolFeature.translate('nickname');
      password.placeholder = await userPoolFeature.translate('password');

      if (!iOS && overlay !== undefined) {
        nickname.focus();
      }

      on(form, EVENT_SUBMIT, async () => {
        DEBUG: if (VERBOSE) console.warn('Login triggered.');
        const user = inject('user');
        const loginData = {
          login: nickname.value,
          password: password.value,
          rememberMe: rememberMe.value,
        };
        await user.login(loginData);
        DEBUG: if (VERBOSE) console.warn('Login Successfull.');
        if (overlay) {
          overlay.close();
        }
      });
    }
  }
);
